'use client';

import { Button } from "@/components/ui/button";
import Link from "next/link";
import Image from "next/image";
import { CheckCircle2 } from 'lucide-react';

function SDPSIHero() {
  return (
    <section className="relative overflow-hidden rounded-2xl border border-white/10 bg-gradient-to-br from-[#06122F] via-[#050B18] to-[#0A1638] p-6 shadow-[0_20px_80px_-50px_rgba(0,0,0,0.8)] md:p-10">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0">
        <div className="absolute -left-24 -top-24 h-80 w-80 rounded-full bg-accent/15 blur-3xl" />
        <div className="absolute -bottom-28 -right-20 h-96 w-96 rounded-full bg-white/10 blur-3xl" />
        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-accent/60 to-transparent" />
      </div>

      <div className="relative grid gap-10 lg:grid-cols-[1.5fr_1fr] lg:items-end">
        <div>
          <h1 className="mt-5 max-w-4xl text-4xl font-bold tracking-tight text-white md:text-6xl">
            Centre de formation en secourisme, securite et prevention des risques
          </h1>

          <h2 className="mt-4 max-w-4xl text-2xl font-semibold tracking-tight text-white/90 md:text-4xl">
            Passez d&apos;une obligation reglementaire a une vraie culture securite
          </h2>

          <p className="mt-5 max-w-3xl text-base text-white/75 md:text-lg">
            Formations SST, incendie, habilitations et prevention des risques concues pour vos realites terrain.
            Nos intervenants accompagnent vos equipes vers des reflexes concrets, mesurables et durables.
          </p>

          <ul className="mt-6 space-y-3 text-sm text-white/90 md:text-base">
            <li className="flex items-start gap-2">
              <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-accent-300" />
              Reponse sous 48h pour vos demandes intra-entreprise.
            </li>
            <li className="flex items-start gap-2">
              <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-accent-300" />
              Parcours adaptes a votre secteur, votre niveau et vos contraintes horaires.
            </li>
            <li className="flex items-start gap-2">
              <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-accent-300" />
              Equipe locale et mobile sur toute la France.
            </li>
          </ul>

          <div className="mt-8 flex flex-wrap gap-3">
            <Button asChild size="lg" variant="cta">
              <Link href="/formations" aria-label="Voir le catalogue des formations SDPSI">
                Voir le catalogue
              </Link>
            </Button>
            <Button asChild size="lg" variant="cta-outline">
              <Link href="/contact" aria-label="Demander un devis de formation">
                Demander un devis
              </Link>
            </Button>
          </div>
        </div>

        <div className="space-y-4">
          <div className="relative aspect-[4/5] overflow-hidden rounded-2xl border border-white/10 bg-white/5">
            <Image
              src="/images/home/Bgsectionhero.webp"
              alt="Formation terrain"
              fill
              className="object-cover"
              sizes="(max-width: 1024px) 100vw, 40vw"
              priority
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050B18]/80 via-transparent to-transparent" />
            <div className="absolute bottom-4 left-4 inline-flex items-center rounded-full bg-white/10 px-3 py-2 text-sm font-semibold text-white border border-white/15 backdrop-blur">
              <CheckCircle2 className="mr-2 h-4 w-4 text-accent-300" />
              Formations opérationnelles
            </div>
          </div>

          <div className="grid grid-cols-3 gap-3 text-center">
            <div className="rounded-2xl border border-white/10 bg-white/5 p-3">
              <p className="text-xl font-bold text-white">560</p>
              <p className="text-xs text-white/60">stagiaires formes en 2024</p>
            </div>
            <div className="rounded-2xl border border-white/10 bg-white/5 p-3">
              <p className="text-xl font-bold text-white">+25</p>
              <p className="text-xs text-white/60">programmes metier</p>
            </div>
            <div className="rounded-2xl border border-white/10 bg-white/5 p-3">
              <p className="text-xl font-bold text-white">2h</p>
              <p className="text-xs text-white/60">moyenne de rappel</p>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-6">
        <Button asChild variant="cta">
          <Link href="/contact" aria-label="Parler a un conseiller formation SDPSI">
            Parler a un conseiller formation
          </Link>
        </Button>
      </div>
    </section>
  );
}

export { SDPSIHero };

